import React from 'react';
import { Link } from "react-router-dom";

const BackToAccount = props => {
    let url = (props.url ? props.url : '/account');

    return <Link to={url} className="back-to-account">Cancel</Link>
}

export default BackToAccount;